import React from 'react'

/**
 * @component
 */
const RequiredMark = ({required}) =>
  required ? <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">*</span> : null

export default RequiredMark
